<p>amortization-table works!</p>
